import { render, staticRenderFns } from "./CallActivityReport.vue?vue&type=template&id=6a504f1e"
import script from "./CallActivityReport.vue?vue&type=script&lang=js"
export * from "./CallActivityReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports